"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var _core = require("@material-ui/core");

var _styles = require("@material-ui/styles");

var _ArrowDropDown = _interopRequireDefault(require("@material-ui/icons/ArrowDropDown"));

var _ArrowRight = _interopRequireDefault(require("@material-ui/icons/ArrowRight"));

var _utils = _interopRequireDefault(require("../../../utils/utils"));

var _DynamicForm = _interopRequireDefault(require("../../DynamicForm"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var useStyles = (0, _styles.makeStyles)(function () {
  return {
    container: {
      diaplay: "flex",
      flex: 1
    },
    iconBtn: {
      padding: 0,
      marginRight: 7
    },
    title: {
      marginTop: 2,
      fontWeight: 500,
      fontSize: 15
    }
  };
});

var Accordion = function Accordion(_ref) {
  var _field$childs;

  var field = _ref.field,
      label = _ref.label,
      _ref$gridSize = _ref.gridSize,
      gridSize = _ref$gridSize === void 0 ? 1 : _ref$gridSize;
  var classes = useStyles();

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      expanded = _useState2[0],
      setExpanded = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      utility = _useState4[0],
      setUtility = _useState4[1];

  var childs = (_field$childs = field.childs) === null || _field$childs === void 0 ? void 0 : _field$childs.map(function (res) {
    res.inside = true;
    return res;
  });
  (0, _react.useEffect)(function () {
    var hasErr = childs === null || childs === void 0 ? void 0 : childs.some(function (child) {
      return child.hasError;
    });

    if (!utility && hasErr) {
      setExpanded(childs === null || childs === void 0 ? void 0 : childs.some(function (child) {
        return child.hasError;
      }));
      setUtility(!utility);
    }
  }, [childs, utility]);

  var handleExpanded = function handleExpanded() {
    setExpanded(function (prev) {
      return !prev;
    });
  };

  var defaultStyles = {};
  var style = !field.isActiveCustomStyles ? defaultStyles : _utils.default.stringToObject(field.customStyles);
  return /*#__PURE__*/React.createElement("div", {
    className: classes.container
  }, /*#__PURE__*/React.createElement(_core.Accordion, {
    style: style,
    expanded: expanded,
    onChange: handleExpanded
  }, /*#__PURE__*/React.createElement(_core.AccordionSummary, {
    "aria-controls": "".concat(field.name, "-content"),
    id: "".concat(field.name, "-header"),
    disabled: field.disabled
  }, /*#__PURE__*/React.createElement(_core.IconButton, {
    "aria-label": "expand",
    component: "span",
    className: classes.iconBtn
  }, expanded ? /*#__PURE__*/React.createElement(_ArrowDropDown.default, null) : /*#__PURE__*/React.createElement(_ArrowRight.default, null)), /*#__PURE__*/React.createElement(_core.Typography, {
    className: classes.title
  }, label)), /*#__PURE__*/React.createElement(_core.AccordionDetails, null, /*#__PURE__*/React.createElement(_DynamicForm.default, {
    definition: childs,
    detail: false,
    editMode: true,
    formId: "",
    gridSize: gridSize // por ahora dejar en 1, luego cambiar a la config del accordion.
    ,
    previewMode: true,
    inside: true
  }))));
};

var _default = Accordion;
exports.default = _default;